export default [
  {
    path: '/salaryPayDirect/payment/edit',
    component: () => import('@/views/salaryPayDirect/payment/paymentEdit/index.vue'),
    name: 'hrManagePaymentEdit',
    meta: { title: '付款单编辑', icon: 'a-up', noCache: true },
    hidden: true
  },
  {
    path: '/salaryPayDirect/payment/details',
    component: () => import('@/views/salaryPayDirect/payment/paymentDetails/index.vue'),
    name: 'hrManagePaymentDetails',
    meta: { title: '付款单详情', icon: 'a-up', noCache: true },
    hidden: true
  },
]
